import { Component } from '../../../../../utils'

@Component({
    template: require('./rootCiricleLoader.html'),
    styles: require('./_rootCircleLoader.scss')
})
export default class rootCircleLoader {
    constructor($rootScope) {
        this.$rootScope = $rootScope;
    }
}

rootCircleLoader.$inject = ["$rootScope"];



// WEBPACK FOOTER //
// ./src/app/common/components/loaders/rootCircleLoader/rootCircleLoader.js